import axios from 'axios';

const state = {
    products: [],
    currentProduct: null,
};

const getters = {
    products: state => state.products,
    currentProduct: state => state.currentProduct,
};

const actions = {
    shop_product_list({ commit }, { shopId, params }) {
        return new Promise((resolve, reject) => {
            axios.get('shop/' + shopId + '/products', { params })
                .then(response => {
                    commit("SET_PRODUCTS", response.data.data.products)
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    shop_product_create({ commit }, { shopId, data }) {
        return new Promise((resolve, reject) => {
            axios.post('shop/' + shopId + '/product', data)
                .then(response => {
                    commit("ADD_PRODUCT", response.data.data.product)
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    shop_product_update({ commit }, { id, data }) {
        return new Promise((resolve, reject) => {
            axios.put('shop/product/' + id, data)
                .then(response => {
                    commit("UPDATE_PRODUCT", response.data.data.product)
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    shop_product_detail({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get('shop/product/' + id)
                .then(response => {
                    commit("SET_CURRENT_PRODUCT", response.data.data.product)
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    shop_product_delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete('shop/product/' + id)
                .then(response => {
                    commit("REMOVE_PRODUCT", id)
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
}

const mutations = {
    SET_PRODUCTS(state, products) {
        state.products = products
    },
    ADD_PRODUCT(state, product) {
        state.products.unshift(product)
    },
    UPDATE_PRODUCT(state, product) {
        const index = state.products.findIndex(p => p.id === product.id)
        if (index !== -1) {
            state.products.splice(index, 1, product)
        }
    },
    REMOVE_PRODUCT(state, id) {
        state.products = state.products.filter(p => p.id !== id)
    },
    SET_CURRENT_PRODUCT(state, product) {
        state.currentProduct = product
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};










